import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutDistanceProfileLookup extends Layout {
    sourceDispatchProfileLookup: DataSource;
    table1: Table;
}
